module.exports = __webpack_public_path__ + "static/animation-map-pin3-64811526608601895fd0f6126bc5e15d.png";